export default __webpack_public_path__ + "static/people-our-story-5c250164efbbf43fb60c9bcb723cc99a.svg";